<div class="focus__wrapper" [class.open]="isOpen">
    <div class="focus__overlay"></div>
</div>
